/* ============================================================================
   MIRRORZONE ACCORDION FUNCTIONALITY - FINAL VERSION
   ============================================================================ */

(function() {
    'use strict';
    
    // Wait for DOM to be fully loaded
    function init() {
        // Get all content sections
        const contentSections = document.querySelectorAll('.contemporary-mirrors-mz-content-section');
        
        if (contentSections.length === 0) {
            console.warn('MirrorZone Accordion: No content sections found');
            return;
        }
        
        // Skip the first section (introduction) - keep it always expanded
        const sectionsToConvert = Array.from(contentSections).slice(1);
        
        if (sectionsToConvert.length === 0) {
            console.warn('MirrorZone Accordion: No sections to convert');
            return;
        }
        
        sectionsToConvert.forEach(function(section) {
            // Find the section title (h2)
            const title = section.querySelector('.contemporary-mirrors-mz-section-title');
            
            if (!title) {
                console.warn('MirrorZone Accordion: No title found in section', section);
                return;
            }
            
            // Make sure content is hidden initially
            section.classList.remove('active');
            
            // Add click event to title
            title.addEventListener('click', function(e) {
                e.preventDefault();
                
                // Toggle active class on this section
                section.classList.toggle('active');
                
                // Update aria-expanded attribute
                const isExpanded = section.classList.contains('active');
                title.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
            });
            
            // Add keyboard accessibility
            title.setAttribute('tabindex', '0');
            title.setAttribute('role', 'button');
            title.setAttribute('aria-expanded', 'false');
            
            // Add keyboard support (Enter and Space keys)
            title.addEventListener('keydown', function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    title.click();
                }
            });
            
            // Add hover effect hint
            title.style.cursor = 'pointer';
        });
        
        console.log('MirrorZone Accordion: Initialized ' + sectionsToConvert.length + ' accordion sections');
    }
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        // DOM is already loaded
        init();
    }
    
})();